import { Box } from "@mui/material";
import { deletedPanTanGstMenu } from "data/constants";
import useQueryParams from "hooks/useQueryParams";
import { useNavigate } from "react-router-dom";
import { StyledProfileNav, StyledProfileNavItem } from "views/clients/styles";
import DeletedIncomeTaxClients from "./deleted-incometax";
import DeletedIncomeTaxTanClients from "./deleted-incometaxtan";
import DeletedGstrClients from "./deleted-gstr";

function DeletedPanTanGst() {
  const navigate = useNavigate();
  const { queryParams } = useQueryParams();
  const active = queryParams.tab || "PAN";

  return (
    <>
      <Box sx={{ position: "sticky", top: 65, bgcolor: "white", zIndex: 2 }}>
        <StyledProfileNav>
          {deletedPanTanGstMenu.map((item, index) => (
            <StyledProfileNavItem
              key={index}
              onClick={() => navigate(`?tab=${item.title}`)}
              active={active === item.title ? 1 : 0}
            >
              {item.title}
            </StyledProfileNavItem>
          ))}
        </StyledProfileNav>
      </Box>
      <Box px={1} py={1} pb={0} mb={0}>
        {active === "PAN" && <DeletedIncomeTaxClients />}
        {active === "TAN/Traces" && <DeletedIncomeTaxTanClients />}
        {active === "GST" && <DeletedGstrClients />}
      </Box>
    </>
  );
}

export default DeletedPanTanGst;
